// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function loadExpressPaymentBundle(baseUrl: string): Promise<any> {
  const polyfillsPath = new URL('web-component/browser/polyfills.js', baseUrl).href;
  await import(/* @vite-ignore */ polyfillsPath);
  const bundlePath = new URL('web-component/browser/main.js', baseUrl).href;
  return import(/* @vite-ignore */ bundlePath);
}
